"use client";
import React, { useContext } from "react";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

const withResponsiveToggle =
  ({ WebView, TabView, MobileView, ResponsiveView }) =>
  (props) => {
    const currentDeviceType = useContext(CurrentDeviceContext);
    const { isMobileDevice: isMobileView, isTabletDevice: isTabletView } = currentDeviceType;

    const isResponsiveView = isMobileView || isTabletView;
    const renderComponent = () => {
      if (isMobileView && MobileView) {
        return <MobileView {...props} />;
      }

      if (isTabletView && TabView) {
        return <TabView {...props} />;
      }

      if (isResponsiveView && ResponsiveView) {
        return <ResponsiveView {...props} />;
      }
      return <WebView {...props} />;
    };
    return renderComponent();
  };

export default withResponsiveToggle;
